import dayjs from 'dayjs';
import { publish } from '../../pubsub';
import useContainerProps from '../helpers/useContainerProps';

/**
 * Fire when user change date range filter in any component
 * @param {Object} container
 * @param {String} startDate
 * @param {String} endDate
 * @param {String} cardType
 *
 */
export default (container, startDate, endDate, cardType = 'fare') => {
  const { eventType } = useContainerProps(container);
  publish(`em.${cardType}.${eventType}.dateRange`, {
    start: dayjs(startDate).format('MM/DD/YYYY'),
    end: dayjs(endDate).format('MM/DD/YYYY')
  });
};
